<template>
  <div class="transfer">
    <div class="breadcrumb-wrap">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/">{{ $t("common.eepay") }}</BreadcrumbItem>
        <BreadcrumbItem>{{ $t("transfer.batchTransfer") }}</BreadcrumbItem>
      </Breadcrumb>
      <a
        class="returnA"
        @click="returnFun"
        v-if="(tabNum == 0 && excelFlag) || tabNum == 1 || tabNum == 2"
      >
        {{ $t("common.back") }}
      </a>
    </div>
    <div class="step-wrap">
      <div class="stepCon active">
        <p class="stepTxt">1.{{ $t("transfer.accountMobileTransfer") }}</p>
      </div>
      <div class="stepCon" :class="{ active: tabNum != 0 }">
        <div class="step active"></div>
        <p class="stepTxt">2.{{ $t("recharge.confirmPay") }}</p>
      </div>
      <div class="stepCon" :class="{ active: tabNum == 2 }">
        <div class="step" :class="{ active: tabNum != 0 }"></div>
        <p class="stepTxt">3.{{ $t("common.done") }}</p>
      </div>
    </div>

    <div class="step-content">
      <div v-show="tabNum == 0" class="tab1">
        <div class="first-step" v-if="!excelFlag">
          <dl>
            <dt>{{ $t("common.importSample") }}</dt>
            <dd class="step-explain">
              <span>
                {{ $t("transfer.importExcelLimitTips") }}
              </span>
              <export-excel
                fileName="example"
                :tHeader="exportHeader"
                :filterVal="exportFilterVal"
                :exportList="exportExcelData"
                :btnText="$t('common.downloadTemplate')"
              />
            </dd>
            <dd class="table-box">
              <img src="@/assets/images/public/excel1.png" />
            </dd>
            <dd class="buttonWarp">
              <import-excel
                :importExcelFlag.sync="importExcelFlag"
                :importExcelModel="importExcelModel"
                @getImportData="getImportData"
              />
            </dd>
          </dl>
        </div>
        <div class="first-step" v-else>
          <dl>
            <dt class="show-number">
              <p class="table-show-explain">
                {{ $t("transfer.accountMobileAmountEditTips") }}
              </p>
              <p class="show-tab">
                <span :class="{ active: showNumber == 0 }" @click="showNum(0)">
                  {{ $t("recharge.totalNumber") }}:
                  {{ Alltotal }}
                  {{ $t("recharge.article") }}
                </span>
                <span :class="{ active: showNumber == 1 }" @click="showNum(1)">
                  {{ $t("recharge.wrongNumber") }}:
                  {{ errorArr.length }}
                  {{ $t("recharge.article") }}
                </span>
                <span :class="{ active: showNumber == 2 }" @click="showNum(2)">
                  {{ $t("recharge.duplicateNumber") }}:
                  {{ repeatArr.length }}
                  {{ $t("recharge.article") }}
                </span>
              </p>
            </dt>
            <dd class="table-box">
              <div class="table-title">
                <span>{{ $t("personal.eepayAccount") }}</span>
                <span>{{ $t("common.mobileNumber") }}</span>
                <span>{{ $t("transfer.transferAmount") }}(PHP)</span>
              </div>
              <ul class="table-list block-color">
                <template v-for="(item, index) in cellphone">
                  <template
                    v-if="
                      index >= (currentPage - 1) * 20 &&
                        index < currentPage * 20
                    "
                  >
                    <li :key="index">
                      <span
                        :class="{
                          'red-color':
                            item.error && (item.error == 1 || item.error == 3),
                          'red-border': item.username == ''
                        }"
                      >
                        <Input
                          v-model="item.username"
                          @on-change="changeUser($event, index)"
                        />
                      </span>
                      <span
                        :class="{
                          'red-color':
                            item.error && (item.error == 1 || item.error == 2),
                          'red-border': item.phone == ''
                        }"
                      >
                        <Input
                          v-model="item.phone"
                          @on-change="changePhone($event, index)"
                        />
                      </span>
                      <span
                        :class="{
                          'red-border':
                            item.money < 0 ||
                            item.money == '' ||
                            item.money == null
                        }"
                      >
                        <InputNumber
                          :min="0"
                          :precision="2"
                          v-model="item.money"
                          @on-change="changeMoney(item.money, index)"
                        ></InputNumber>
                      </span>
                      <a class="close-btn" @click="deletePhone(index)">
                        <Icon
                          type="ios-close-circle"
                          color="#C3C3C3"
                          size="25"
                        />
                      </a>
                    </li>
                  </template>
                </template>
              </ul>
            </dd>
            <dd class="table-handle">
              <Page
                size="small"
                :total="cellphone.length"
                :page-size="20"
                :current.sync="currentPage"
                show-total
                @on-change="pageChange"
              />
              <p>
                <a href="javascript:void(0);" @click="deleteError">
                  {{ $t("recharge.wrongRemoval") }}
                </a>
                <a href="javascript:void(0);" @click="deleteRepeat">
                  {{ $t("recharge.repetitiveRemoval") }}
                </a>
              </p>
            </dd>
            <dd class="buttonWarp">
              <Button type="primary" long @click="nextStepFun">
                {{ $t("common.nextStep") }}
              </Button>
            </dd>
          </dl>
        </div>
      </div>
      <div v-if="tabNum == 1" class="tab2 second-step">
        <dl>
          <dd class="table-box">
            <div class="table-title">
              <span>{{ $t("personal.eepayAccount") }}</span>
              <span>{{ $t("common.mobileNumber") }}</span>
              <span>{{ $t("transfer.transferAmount") }}(PHP)</span>
            </div>
            <ul class="table-list block-color">
              <template v-for="(item, index) in telArr">
                <template
                  v-if="
                    index >= (currentPage - 1) * 20 && index < currentPage * 20
                  "
                >
                  <li :key="index">
                    <span>{{ item.username }}</span>
                    <span>{{ item.phone }}</span>
                    <span>
                      {{ (Math.round(item.money * 100) / 100).toFixed(2) }}
                    </span>
                  </li>
                </template>
              </template>
            </ul>
          </dd>
          <dd class="table-handle">
            <Page
              size="small"
              :total="telArr.length"
              :page-size="20"
              :current.sync="currentPage"
              show-total
              @on-change="pageChange"
            />
            <p class="red-color">
              {{ $t("transfer.total") }}：
              <span>{{ Number(totalMoney).toFixed(2) }}</span>
              P
            </p>
          </dd>
          <dd class="table-input table-input-explain">
            <span>{{ $t("transfer.transferDesc") }}：</span>
            <Input
              v-model="remark"
              :maxlength="20"
              :placeholder="$t('transfer.transferDesc')"
            />
          </dd>
          <dd class="table-input">
            <span>{{ $t("common.payPsd") }}：</span>
            <div class="password">
              <div class="inputPsd">
                <Input
                  v-model="payPsd"
                  type="password"
                  password
                  :placeholder="$t('common.enterPayPsd')"
                />
              </div>
            </div>
            <!-- <Input v-model="payPsd" type="password" :password="true" placeholder="支付密码" /> -->
          </dd>
          <dd class="buttonWarp">
            <Button
              type="primary"
              long
              :loading="submitLoading"
              @click="submitJump"
            >
              {{ $t("transfer.confirmTransfer") }}
            </Button>
          </dd>
        </dl>
      </div>
      <div v-if="tabNum == 2" class="tab3">
        <detail
          v-if="detailFlag"
          :detailFlag.sync="detailFlag"
          :order_id="detail.order_id"
          :type="3"
          @getSubOrder="getSubOrder"
        />
        <!-- 批量充值子订单充值记录 -->
        <sub-order v-if="subOrderFlag" :data="subOrderData" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Detail from "@/components/detail";
import SubOrder from "@/components/detail/subOrder";
import ImportExcel from "@/components/excel/import";
import ExportExcel from "@/components/excel/export";
export default {
  name: "transfer-batch",
  components: {
    Detail,
    SubOrder,
    ImportExcel,
    ExportExcel
  },
  data() {
    return {
      tabNum: 0, //充值步骤下标
      showNumber: 0, //显示全部/错误/重复号码

      excelFlag: false, //是否导入表格
      currentPage: 1, //当前页码

      cellphone: [], //输入框的号码，当前页面显示的号码
      telArr: [], //导入的号码数组，总号码数组
      successArr: [], //输入的号码的成功数组
      errorArr: [], //输入的号码的错误数组
      repeatArr: [], //输入的号码的重复数组
      Alltotal: 0, //总条数

      totalMoney: 0,
      remark: "",
      payPsd: "",

      submitLoading: false,

      detailFlag: false, // 详情页Flag
      detail: {},
      subOrderFlag: false, // 子订单Flag
      subOrderData: {}, // 返现订单Id

      importExcelFlag: false,
      importExcelModel: [
        { label: this.$t("personal.eepayAccount"), value: "username" },
        { label: this.$t("common.mobileNumber"), value: "phone" },
        { label: this.$t("transfer.transferAmount") + "(PHP)", value: "money" }
      ],

      excelLoad: false,
      exportHeader: [
        this.$t("personal.eepayAccount"),
        this.$t("common.mobileNumber"),
        this.$t("transfer.transferAmount") + "(PHP)"
      ],
      exportFilterVal: ["username", "phone", "money"],
      exportExcelData: []
    };
  },
  created() {
    //初始化表格示例添加10条数据
    for (let i = 0; i < 10; i++) {
      var obj = {};
      obj.username = "username";
      obj.phone = "09271111111";
      obj.money = 100;
      this.exportExcelData.push(obj);
    }
  },
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    getSubOrder(data) {
      // 获取子订单数据
      let vm = this;
      console.log("getSubOrder", data);
      vm.subOrderFlag = true;
      vm.subOrderData = data;

      vm.detailFlag = false;
    },
    submitJump() {
      //第二步
      //点击确认转账
      let vm = this;
      //判断余额是否够支付
      if (vm.userInfo.money_usable < vm.totalMoney) {
        vm.$Message.info(vm.$t("common.balanceInsufficientRecharge"));
        return;
      }
      //判断是否输入支付密码
      if (vm.payPsd == "") {
        vm.$Message.info(vm.$t("common.enterPayPsd"));
        return;
      }
      //验证支付密码是否正确
      let params = {};
      params.pay_password = vm.payPsd;
      vm.submitLoading = true;
      vm.$post("/app/user/validatePayPassword", params, { alert: true }).then(
        res => {
          if (res.code == 0) {
            //密码正确则提交订单
            vm._getPayment();
          } else {
            vm.$Message.error(res.msg);
            vm.submitLoading = false;
          }
        }
      );
    },
    _getPayment() {
      //订单提交
      let vm = this;
      let params = {};
      let obj = {};
      obj.data = vm.telArr;
      params.pay_password = vm.payPsd;
      params.remark = vm.remark;
      params.data = JSON.stringify(obj);
      vm.submitLoading = true;
      vm.$post("/app/transfer/batchTranfer", params, {
        alert: true
      }).then(res => {
        console.log("batchTranfer", res);
        vm.submitLoading = false;
        if (res.code == 0) {
          vm.orderFlag = true;
          vm.detail = res.data.list[0];
          vm.tabNum = 2;
          vm.detailFlag = true;
          vm.remark = "";
          vm.payPsd = "";
          vm.$store.dispatch("GET_USER_INFO");
        } else {
          vm.$Message.error(res.msg);
        }
      });
    },
    nextStepFun() {
      //点击下一步
      let vm = this;
      // vm.tabNum = 1;
      //判断当前列表信息是否完整
      for (let i = 0; i < vm.telArr.length; i++) {
        if (
          vm.telArr[i].username == "" ||
          vm.telArr[i].phone == "" ||
          vm.telArr[i].money == "" ||
          vm.telArr[i].money == null
        ) {
          vm.$Message.info(vm.$t("transfer.incompleteInformation"));
          return;
        }
      }
      //判断金额
      for (let i = 0; i < vm.telArr.length; i++) {
        if (vm.telArr[i].money == 0 || vm.telArr[i].money <= 0) {
          vm.$Message.info(vm.$t("common.enterCorrectAmount"));
          return;
        }
      }
      //判断页面是否有红色，弹窗提示错误号码
      let flag = true;
      for (let i = 0; i < vm.telArr.length; i++) {
        if (vm.telArr[i].error || vm.telArr[i].error == 0) {
          flag = false;
          break;
        }
      }
      //判断是否有重复号码，弹窗
      if (vm.repeatArr.length > 0 || vm.errorArr.length > 0 || !flag) {
        vm.$Modal.confirm({
          content: vm.$t("transfer.wrongNumberTransferTips"),
          onOk: () => {
            //统计余额
            vm.totalMoney = 0;
            for (let i = 0; i < vm.telArr.length; i++) {
              vm.totalMoney = vm.addFloat(vm.totalMoney, vm.telArr[i].money);
            }
            vm.tabNum = 1;
          }
        });
        return;
      }
      //统计余额
      vm.totalMoney = 0;
      for (let i = 0; i < vm.telArr.length; i++) {
        vm.totalMoney = vm.addFloat(vm.totalMoney, vm.telArr[i].money);
      }
      vm.tabNum = 1;
    },
    pageChange(data) {
      //修改页码
      let vm = this;
      vm.currentPage = data;
    },
    deletePhone(index) {
      //删除该条数据
      let vm = this;
      this.$Modal.confirm({
        content: vm.$t("transfer.wantDeleteMessage"),
        onOk: function() {
          let arr = [];
          if (vm.showNumber == 0) {
            arr = JSON.parse(JSON.stringify(vm.telArr));
            arr.splice(index, 1);
          } else if (vm.showNumber == 1) {
            arr = JSON.parse(JSON.stringify(vm.errorArr));
            arr.splice(index, 1);
            arr = arr.concat(vm.repeatArr);
            arr = arr.concat(vm.successArr);
            vm.telArr = JSON.parse(JSON.stringify(arr));
          } else if (vm.showNumber == 2) {
            arr = JSON.parse(JSON.stringify(vm.repeatArr));
            arr.splice(index, 1);
            arr = arr.concat(vm.errorArr);
            arr = arr.concat(vm.successArr);
          }
          vm.telArr = JSON.parse(JSON.stringify(arr));
          vm.updateSercond(vm.telArr);
        },
        onCancel: function() {}
      });
    },
    getImportData(data) {
      // 获取导入数据
      console.log("getImportData", data);
      let vm = this;
      if (data.length > 1000) {
        vm.importExcelFlag = false;
        vm.$Modal.error({
          content: vm.$t("recharge.importUpperLimitTips"),
          onOk: function() {
            vm.$emit("update:excelFlag", false);
          }
        });
        return false;
      }
      let newData = vm.updateFirst(data);
      if (newData.length) {
        vm.checkNumber(newData);
      } else {
        vm.excelFlag = false;
      }
    },
    updateFirst(arr) {
      //第一次处理号码，判断号码格式以及金额是否是正数
      let vm = this;
      let flag = true;
      //先判断所有的号码是否是以09/09/8/9开头，并且是11/10位数字
      //如果不是，则该号码为错误号码
      for (let i = 0; i < arr.length; i++) {
        //将当前号码转成数字类型,并取出第一位数字和长度
        if (arr[i] != "") {
          let thisNum = Number((arr[i].phone + "").replace(/\s/g, "")); //清除号码中的空格
          let thisFirst = thisNum.toString().split("")[0]; //取号码的第一位数字
          let thisLength = thisNum.toString().length; //号码长度
          let thisMoney = Number(arr[i].money);
          //判断号码格式是否正确,号码转数字类型的长度是10位
          //判断金额为正整数
          if (
            thisLength != 10 ||
            (thisFirst != "8" && thisFirst != "9") ||
            thisMoney < 0 ||
            isNaN(thisMoney)
          ) {
            flag = false;
            break;
          }
        }
      }
      if (!flag) {
        vm.$Modal.error({
          content: vm.$t("recharge.importExcelDataFormatTips"),
          onOk: function() {
            vm.importExcelFlag = false;
            return [];
          }
        });
        return [];
      } else {
        //所有正确号码补0,以及金额转化为数字
        for (let i = 0; i < arr.length; i++) {
          arr[i].phone = "0" + Number((arr[i].phone + "").replace(/\s/g, ""));
          arr[i].money = Number(parseFloat(arr[i].money).toFixed(2));
        }
        return arr;
      }
    },
    checkNumber(arr) {
      //请求接口判断号码用户名是否正确
      let vm = this;
      let params = {};
      params.list = JSON.stringify(arr);
      vm.$post("/app/transfer/checkTransferUserLists", params, {
        alert: true
      }).then(res => {
        console.log("checkTransferUserLists", res);
        vm.importExcelFlag = false;
        if (res.code == 0) {
          vm.excelFlag = true;

          let list = res.data.list;
          let newList = [];
          for (let i = 0; i < list.length; i++) {
            let curI = list[i];
            curI.money = Number(curI.money);
            newList.push(curI);
          }
          vm.telArr = newList;

          vm.updateSercond(vm.telArr);
        } else {
          vm.$Message.error(res.msg);
        }
      });
    },
    changeUser(event, index) {
      //修改用户名
      let vm = this;
      //先判断当前是否显示红字
      let newArr = [];
      newArr = JSON.parse(JSON.stringify(vm.telArr));
      if (newArr[index].error) {
        if (newArr[index].error == 1) {
          newArr[index].error = 2;
        } else if (newArr[index].error == 3) {
          vm.$delete(newArr[index], "error");
        }
      }
      newArr[index].username = event.target.value;
      vm.telArr = JSON.parse(JSON.stringify(newArr));
      vm.updateSercond(vm.telArr);
    },
    changePhone(event, index) {
      //修改手机号
      let vm = this;
      let value = event.target.value;
      let regular = /^0?[89]\d{9}$/;
      // let regular = /^[0-9]*$/
      if (!regular.test(value)) {
        vm.$set(vm.cellphone[index], "error", 2);
        // vm.$set(vm.cellphone[index], 'phone', event.target._value)
        // vm.$set(vm.cellphone[index], 'phone', '')
        // setTimeout(()=> {
        //   // vm.$set(vm.cellphone[index], 'phone', '')
        //   vm.$set(vm.cellphone[index], 'error', 2)
        //   // console.log('vm.cellphone[index]', oldValue)
        // }, 20)
        return false;
      }

      //先判断当前是否显示红字
      let newArr = [];
      newArr = JSON.parse(JSON.stringify(vm.telArr));
      if (newArr[index].error) {
        if (newArr[index].error == 1) {
          newArr[index].error = 3;
        } else if (newArr[index].error == 2) {
          vm.$delete(newArr[index], "error");
        }
      }

      newArr[index].phone = "0" + Number(value);
      vm.telArr = JSON.parse(JSON.stringify(newArr));
      vm.updateSercond(vm.telArr);
    },
    changeMoney(value, index) {
      //修改金额
      let vm = this;
      let newArr = [];
      newArr = JSON.parse(JSON.stringify(vm.telArr));
      newArr[index].money = value;
      console.log(newArr[index].money);
      vm.telArr = JSON.parse(JSON.stringify(newArr));
      vm.updateSercond(vm.telArr);
    },
    updateSercond(arr) {
      //第二次处理号码，处理是否重复错误
      let vm = this;
      vm.successArr = [];
      vm.errorArr = [];
      vm.repeatArr = [];
      //通过判断数组中的对象
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].error) {
          //添加至错误号码中
          vm.errorArr.push(arr[i]);
        } else {
          vm.successArr.push(arr[i]);
        }
      }
      let newSuccess = [];
      //正确的号码补0之后再判断是否存在重复号码
      for (let i = 0; i < vm.successArr.length; i++) {
        let flag = true;
        for (let j = 0; j < newSuccess.length; j++) {
          if (
            newSuccess[j].username == vm.successArr[i].username &&
            newSuccess[j].phone == vm.successArr[i].phone
          ) {
            flag = false;
            vm.repeatArr.push(vm.successArr[i]);
            break;
          }
        }
        if (flag) {
          newSuccess.push(vm.successArr[i]);
        }
      }
      vm.successArr = JSON.parse(JSON.stringify(newSuccess));
      //渲染至页面
      let newArr = [];
      newArr = JSON.parse(JSON.stringify(arr));
      vm.cellphone = JSON.parse(JSON.stringify(newArr));
      console.log(vm.cellphone);
      //条数显示
      vm.Alltotal = arr.length; //总条数
      //展示当前选择的显示的数据
      vm.showNum(vm.showNumber);
    },
    showNum(type) {
      //显示当前的号码
      let vm = this;
      vm.showNumber = type;
      let newArr = [];
      if (type == 0) {
        newArr = JSON.parse(JSON.stringify(vm.telArr));
      } else if (type == 1) {
        newArr = JSON.parse(JSON.stringify(vm.errorArr));
      } else if (type == 2) {
        newArr = JSON.parse(JSON.stringify(vm.repeatArr));
      }
      // for(let i=0;i<newArr.length;i++){
      //   newArr[i].phone = newArr[i].phone.replace(/\s/g,'').replace(/(0?\d{4})(\d{3})(\d{4})/, '$1 $2 $3');
      // }
      vm.cellphone = newArr;
    },
    deleteRepeat() {
      //去重复
      let vm = this;
      if (!vm.repeatArr.length) {
        return;
      }
      vm.repeatArr = [];
      vm.telArr = JSON.parse(JSON.stringify(vm.successArr.concat(vm.errorArr)));
      console.log(vm.telArr);
      vm.updateSercond(vm.telArr);
    },
    deleteError() {
      //去错误
      let vm = this;
      if (!vm.errorArr.length) {
        return;
      }
      vm.errorArr = [];
      vm.telArr = JSON.parse(
        JSON.stringify(vm.successArr.concat(vm.repeatArr))
      );
      if (!vm.telArr.length) {
        vm.excelFlag = false;
        return;
      }
      vm.updateSercond(vm.telArr);
      // vm.showNum(vm.showNumber);
    },
    returnFun() {
      //返回按钮
      let vm = this;
      if (vm.tabNum == 0) {
        if (vm.excelFlag) {
          vm.excelFlag = false;
        }
      } else if (vm.tabNum == 1) {
        if (vm.orderFlag) {
          vm.excelFlag = false;
        }
        vm.tabNum = 0;
      } else if (vm.tabNum == 2) {
        if (vm.subOrderFlag) {
          vm.detailFlag = true;

          vm.subOrderFlag = false;
          vm.batch_id = "";
          vm.order_id = "";
          vm.state = 0;
        } else {
          vm.tabNum = 0;
          vm.excelFlag = false;
          vm.remark = "";
          vm.payPsd = "";

          vm.detailFlag = false;
          vm.orderId = "";

          vm.subOrderFlag = false;
          vm.batch_id = "";
          vm.order_id = "";
          vm.state = 0;
        }
      }
      if (vm.orderFlag) {
        vm.cellphone = "";
        vm.successArr = [];
        vm.Alltotal = 0;
        vm.orderFlag = false;
      }
      //默认显示总条数
      // vm.showNumber = 0;
    },
    addFloat(a, b) {
      var c, d, e;
      try {
        c = a.toString().split(".")[1].length;
      } catch (f) {
        c = 0;
      }
      try {
        d = b.toString().split(".")[1].length;
      } catch (f) {
        d = 0;
      }
      return (
        (e = Math.pow(10, Math.max(c, d))),
        (Number(this._PHPtoRMB(a, e)) + Number(this._PHPtoRMB(b, e))) / e
      );
    }
  },
  watch: {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.red-color {
  color: #d80000;
}
.step-content {
  padding: 0 50px;
  /deep/.detail-wrap,
  /deep/.list-wrap {
    padding: 0;
  }
  .first-step,
  .second-step {
    dl {
      dt {
        font-size: 18px;
        color: #4a4a4a;
        font-weight: 500;
        line-height: 25px;
        &.show-number {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .table-show-explain {
            font-size: 14px;
          }
          .show-tab {
            text-align: right;
            margin-bottom: 10px;
            font-size: 14px;
            span {
              color: #666;
              padding: 0 9px;
              line-height: 24px;
              cursor: pointer;
              &.active {
                position: relative;
                color: #2042ab;
              }
              &.active:after {
                content: "";
                height: 3px;
                width: calc(100% - 18px);
                background: #2042ab;
                position: absolute;
                left: 9px;
                bottom: -15px;
              }
            }
            span + span {
              border-left: 1px solid #b6b6b6;
            }
          }
        }
      }
      dd.step-explain {
        display: flex;
        justify-content: space-between;
        color: #4a4a4a;
        font-size: 14px;
        margin: 6px 0;
      }
      dd.table-box {
        color: #4a4a4a;
        font-size: 14px;
        border: 1px solid rgba(215, 215, 215, 0.5);
        .table-title {
          height: 46px;
          background: #f3f3f3;
          color: #030303;
          display: flex;
          align-items: center;
          border-bottom: 1px solid rgba(215, 215, 215, 0.5);
          span {
            flex: 1;
            height: 100%;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          span + span {
            border-left: 1px solid rgba(215, 215, 215, 0.5);
          }
        }
        .table-list {
          li {
            height: 40px;
            display: flex;
            align-items: center;
            position: relative;
            span {
              flex: 1;
              height: 100%;
              font-size: 14px;
              display: flex;
              align-items: center;
              justify-content: center;
              &.red-color {
                /deep/.ivu-input {
                  color: #d80000;
                }
              }
              /deep/.ivu-input-suffix {
                display: none;
              }
              &.red-border {
                /deep/.ivu-input,
                /deep/.ivu-input-number-input {
                  border: 1px solid red;
                }
              }
            }
            span + span {
              border-left: 1px solid rgba(215, 215, 215, 0.5);
            }
            .close-btn {
              position: absolute;
              top: 50%;
              right: -36px;
              transform: translateY(-50%);
            }
          }
          li + li {
            border-top: 1px solid rgba(215, 215, 215, 0.5);
          }
          /deep/.ivu-input-number,
          /deep/.ivu-input-inner-container,
          /deep/.ivu-input-number-input-wrap,
          /deep/.ivu-input-number-input,
          /deep/.ivu-input-wrapper,
          /deep/.ivu-input {
            width: 100%;
            height: 100%;
            text-align: center;
            border: 0;
            font-size: 14px;
            background: none;
          }
          /deep/.ivu-input-number,
          /deep/.ivu-input-wrapper {
            height: calc(100% - 2px);
            background: none;
          }
          /deep/.ivu-input-number-handler {
            height: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: none;
          }
          &.block-color {
            li:nth-child(even) {
              background: #fbfcfe;
            }
          }
        }
      }
      dd.table-handle {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 10px 0;
        font-size: 14px;
        p {
          a {
            color: #fe7800;
            text-decoration: underline;
            margin-left: 20px;
          }
        }
      }
      dd.buttonWarp {
        width: 300px;
        margin: 0 auto;
        margin-top: 40px;
        position: relative;
        button {
          height: 45px;
          font-size: 20px;
        }
      }
      dd.table-input {
        display: flex;
        align-items: center;
        margin: 20px 0;
        color: #333333;
        /deep/.ivu-input-inner-container {
          height: 100%;
        }
        /deep/.ivu-input-wrapper {
          width: 320px;
          height: 48px;
        }
        /deep/.ivu-input {
          height: calc(100% - 2px);
          color: #2042ab;
          border-color: #2042ab;
        }
        /deep/.ivu-icon {
          font-size: 20px;
          line-height: 48px;
        }
        &.table-input-explain {
          /deep/.ivu-input {
            font-size: 16px;
          }
        }
        .password {
          width: 320px;
          .inputPsd {
            height: 48px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border: 1px solid #2042ab;
            border-radius: 5px;
            /deep/.ivu-input-wrapper {
              height: 46px;
            }
            /deep/.ivu-input {
              border: 0;
              height: 46px;
              padding-right: 40px;
              line-height: 46px;
              font-size: 16px;
              color: #2042ab;
            }
            /deep/.ivu-input-suffix {
              cursor: pointer;
              width: 40px;
              display: flex;
              justify-content: center;
              align-items: center;
              .ivu-icon {
                font-size: 22px;
                color: #2042ab;
              }
            }
          }
        }
      }
    }
  }
}

.modal-container {
  p {
    font-size: 14px;
    color: #4a4a4a;
    line-height: 28px;
    margin-bottom: 20px;
  }
}
.footer {
  position: relative;
  .file {
    position: absolute;
    width: 330px;
    height: 45px;
    font-size: 20px;
    opacity: 0;
  }
  .tips {
    width: 330px;
    text-align: center;
    font-size: 12px;
    color: #9b9b9b;
    padding-top: 10px;
  }
  .skip {
    display: block;
    margin-top: 24px;
    color: #2042ab;
    font-size: 16px;
    line-height: 22px;
    text-decoration: underline;
  }
  /deep/.ivu-btn-primary.text-gray {
    background: #b6b6b6;
    color: #ddd;
  }
  /deep/.ivu-btn-primary.text-gray:focus {
    box-shadow: 0 0 0 2px #ddd;
  }
}
</style>
